import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LandingHeader } from '../components/LandingHeader';
import { blogPosts, formatPostDate } from '../data/blogPosts';
export function BlogPage() {
  const [featured, ...rest] = blogPosts;
  return <div id="top" className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-552" data-mp="3me43bt2zaj5m">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-50 rounded-lg bg-[#041F60] px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-553" data-mp="3r9swneoen3th">
        Skip to content
      </a>
      <LandingHeader data-id="element-554" data-mp="33l04zuetfi4o" />

      <main id="main-content" data-id="element-555" data-mp="33ki4ump18jrh">
        <section className="border-b border-[#A6B6F8]/50 bg-[#A6B6F8]/20" data-id="element-556" data-mp="33nmcju1phxmw">
          <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-557" data-mp="38le7kwxndzvb">
            <div className="max-w-2xl" data-id="element-558" data-mp="iw3p3w6txhjk">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-559" data-mp="iv13a2od65ai">
                Insights
              </p>
              <h1 className="mt-3 text-4xl font-bold tracking-[-0.045em] sm:text-5xl sm:leading-[1.06]" data-id="element-560" data-mp="1retq6ngujz6a">
                Practical writing on credit, collections and cash.
              </h1>
              <p className="mt-5 text-base leading-7 text-[#3A3A3A] sm:text-lg" data-id="element-561" data-mp="1iedmpe03ss1f">
                Short, useful pieces for owners and finance teams who would
                rather spend less time chasing invoices.
              </p>
            </div>

            <article className="mt-12 grid gap-8 rounded-2xl border border-[#A6B6F8]/60 bg-white p-6 sm:p-9 lg:grid-cols-[1.25fr_0.75fr] lg:items-end lg:gap-14" data-id="element-562" data-mp="18gzj4eza3xqj">
              <div data-id="element-563" data-mp="yq4uj3yk8m1x">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-564" data-mp="yrg099bkg3vo">
                  <span className="rounded-full bg-[#4BE4FF] px-2.5 py-1 text-[#041F60]" data-id="element-565" data-mp="umq4rlktkrba">
                    Latest
                  </span>
                  <span data-id="element-566" data-mp="kq3m93fyuccf">{featured.category}</span>
                </div>
                <h2 className="mt-5 text-2xl font-bold tracking-[-0.035em] sm:text-3xl sm:leading-tight" data-id="element-567" data-mp="kszkksvq731e">
                  <a href={`/blog/${featured.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-568" data-mp="g247r38wpzqi">
                    {featured.title}
                  </a>
                </h2>
                <p className="mt-4 max-w-xl text-base leading-7 text-[#3A3A3A]" data-id="element-569" data-mp="660tiz0s6an7">
                  {featured.excerpt}
                </p>
              </div>
              <div className="lg:text-right" data-id="element-570" data-mp="ysvery5f9e1q">
                <p className="text-sm font-semibold text-[#041F60]" data-id="element-571" data-mp="yuohx3gttg4z">
                  {formatPostDate(featured.date)}
                </p>
                <p className="mt-1 text-sm text-stone-500" data-id="element-572" data-mp="p2adu429zxfn">
                  {featured.readingMinutes} min read ·{' '}
                  {featured.author}
                </p>
                <a href={`/blog/${featured.slug}`} className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#041F60] px-5 py-3.5 text-sm font-bold text-white transition hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-573" data-mp="1hj38xqr58u5s">
                  Read article <ArrowRightIcon size={17} aria-hidden="true" data-id="element-574" data-mp="3bzlam6mktabl" />
                </a>
              </div>
            </article>
          </div>
        </section>

        <section className="bg-white" data-id="element-575" data-mp="372l2lq661xhu">
          <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-576" data-mp="2j9utrptk7ubs">
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-577" data-mp="2ebt9x2ob7qz9">
              More articles
            </h2>
            <ul className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-578" data-mp="2sc40e4lpj3jw">
              {rest.map(post => <li key={post.slug} className="h-full" data-id="element-579" data-mp="2o862fx84bysf">
                  <article className="flex h-full flex-col rounded-2xl border border-[#A6B6F8]/50 bg-white p-6" data-id="element-580" data-mp="7kkbj8b9ta1w">
                    <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-581" data-mp="3k9yjbp29jdj">
                      {post.category}
                    </p>
                    <h3 className="mt-3 text-lg font-bold leading-snug tracking-tight" data-id="element-582" data-mp="yw182xhssi9l">
                      <a href={`/blog/${post.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-583" data-mp="12xcuyv9aepe3">
                        {post.title}
                      </a>
                    </h3>
                    <p className="mt-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-584" data-mp="1hqgcj2mvp34t">
                      {post.excerpt}
                    </p>
                    <p className="mt-auto pt-6 text-xs font-semibold text-stone-500" data-id="element-585" data-mp="1ql4ccd9opsm8">
                      {formatPostDate(post.date)} · {post.readingMinutes} min
                      read
                    </p>
                  </article>
                </li>)}
            </ul>
          </div>
        </section>

        <section className="navy-texture border-t border-[#031849] text-white" data-id="element-586" data-mp="25j6k6znr109a">
          <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-5 py-14 sm:px-8 sm:py-20 md:flex-row md:items-center" data-id="element-587" data-mp="3q0p9pmz7j2nc">
            <div className="max-w-xl" data-id="element-588" data-mp="3l35uajqrwjtt">
              <h2 className="text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-589" data-mp="3g1gfqu4cdo0z">
                Stop reading about late payment. Start fixing it.
              </h2>
              <p className="mt-3 text-base leading-7 text-[#A6B6F8]" data-id="element-590" data-mp="3b59kpwdhhwxt">
                Start your free trial and bring credit, collections and invoice
                finance into one practical view.
              </p>
            </div>
            <a href="/signup" className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#4BE4FF] px-5 py-3.5 text-sm font-bold text-[#041F60] transition hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-591" data-mp="2uy6yxqibbjq">
              Start your free trial{' '}
              <ArrowRightIcon size={17} aria-hidden="true" data-id="element-592" data-mp="qiy187n11k32" />
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-white" data-id="element-593" data-mp="2prpt84nhl2bo">
        <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-594" data-mp="2pqxzkzdg9eo1">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-595" data-mp="2b2te5nn0ip1k">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-596" data-mp="2g0len61q3jhd">
            Contact support
          </a>
          <p className="text-xs text-stone-500" data-id="element-597" data-mp="1s5s6fv22qatx">© 2026 Credit Manager</p>
        </div>
      </footer>
    </div>;
}